import { render, staticRenderFns } from "./groupsList.vue?vue&type=template&id=675ce026&scoped=true"
import script from "./groupsList.vue?vue&type=script&lang=js"
export * from "./groupsList.vue?vue&type=script&lang=js"
import style0 from "./groupsList.vue?vue&type=style&index=0&id=675ce026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ce026",
  null
  
)

export default component.exports